import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.Title',
    defaultMessage: 'Add Miscellaneous Accounting Record',
  },
  modalDescription: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.Description',
    defaultMessage:
      'Provide the Miscellaneous Accounting details below to create the record on this voucher.',
  },
  cancel: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.Cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.Save',
    defaultMessage: 'Save',
  },
  miscRequestTypeLabel: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.MiscRequestTypeLabel',
    defaultMessage: 'Misc. Request Type',
  },
  miscRequestTypePlaceholder: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.MiscRequestTypePlaceholder',
    defaultMessage: 'Select an option',
  },
  commentsLabel: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.CommentsLabel',
    defaultMessage: 'Comments',
  },
  commentsPlaceholder: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.CommentsPlaceholder',
    defaultMessage: 'Enter note',
  },
  commentsError: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.CommentsError',
    defaultMessage: 'Comments cannot exceed 78 characters.',
  },
  requestedAmountLabel: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.RequestedAmountLabel',
    defaultMessage: 'Amount Requested',
  },
  chargeCodeLabel: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.ChargeCodeLabel',
    defaultMessage: 'Charge Code',
  },
  chargeCodePlaceholder: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.ChargeCodePlaceholder',
    defaultMessage: 'Charge Code',
  },
  chargeCodeTooltip: {
    id: 'App.ManageHudVoucherDetails.MiscellaneousAccounting.AddModal.ChargeCodeTooltip',
    defaultMessage:
      'The selected charge code will be used when posting any applicable payment(s)' +
      ' after the HUD voucher has been approved.',
  },
});
